module.exports = __webpack_public_path__ + "assets/boomerang_print.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang_print.png
// module id = 317
// module chunks = 0